/**
 * 手元で絞った一覧が、取得の上限(先頭 N 件)で切れているときの注記(UX1-b2 fix1 中4)。
 *
 * サーバーに無い条件(文字検索・期限超過・自分が承認者・複数選択)は一覧 API の並びで先頭 N 件を読んで手元で
 * 絞る。N 件を超える分は対象外なので、「該当なし」が本当に無いのか分からない。表の上に
 * これを出し、件数は「N 件中 M 件」(DataTable の `countLabel`)、空状態にも同じ一文を添える。
 * 「条件を外して全件を見る」で手元の条件を全部外し、サーバー側のページングに戻す。
 */
import { Alert, Button } from "antd";

import { PARTIAL_CLEAR_LABEL, partialResultText } from "./partialResult";

export function PartialResultNote({ limit, onClear }: { limit: number; onClear: () => void }) {
  return (
    <Alert
      type="warning"
      showIcon
      className="ui-partial-note"
      message={partialResultText(limit)}
      action={
        <Button size="small" onClick={onClear}>
          {PARTIAL_CLEAR_LABEL}
        </Button>
      }
    />
  );
}
